import { Dict } from "mixpanel-browser";

export interface TrackingService {
	enable(value: boolean): void;
	enableGA(): void;
	isEnabled(): boolean;
	time(event: string): void;
	track(event: string, properties?: { [key: string]: unknown }): void;
	logPageView(url: string): void;
	enableGTM(): void;
	updateProfile(id: string, properties: Dict): void;
}

export class LocalTrackingService implements TrackingService {
	enable(): void {}
	enableGA(): void {}
	isEnabled(): boolean {
		return false;
	}
	time(): void {}
	track(): void {}
	logPageView(): void {}
	enableGTM(): void {}
	updateProfile(): void {}
}
